import { SET_ONBOARDING_STEP, SET_ONBOARDING_STATUS } from './onboardingTypes';

export const setOnboaringStep = (step) => {
  return {
    type: SET_ONBOARDING_STEP,
    payload: step,
  };
};

export const setOnboaringStatus = (status) => {
  return {
    type: SET_ONBOARDING_STATUS,
    payload: status,
  };
};
